var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterPatern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 708,
    height: 700,
    viewBox: "0 0 708 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1079.5 293.386C1059.14 163.388 862.7 81.7514 715.524 84.1298C545.92 86.8868 482.719 200.567 353.419 166.714C235.425 135.859 227.777 25.3525 141.068 8.35381C61.3805 -7.26475 -64.125 60.1802 -269.542 392.003",
    stroke: "url(#paint0_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-259.56 406.592C-56.6335 79.5634 68.9276 9.53642 149.725 22.1862C209.608 31.6377 233.006 85.2015 280.079 126.931C303.579 148.415 332.413 164.112 363.994 172.612C467.439 200.53 528.586 137.327 638.762 109.805C666.844 102.711 695.723 98.7273 724.805 97.9367C872.568 93.4677 1066.75 164.114 1090.11 289.361",
    stroke: "url(#paint1_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-249.552 421.139C-49.1168 98.9259 76.4278 26.3398 158.167 36.044C218.251 43.1822 243.002 94.1801 290.157 133.777C314.211 154.481 343 169.782 374.33 178.513C476.29 206.91 537.453 149.948 648.02 123.682C676.118 116.951 704.889 112.959 733.871 111.769C882.248 105.636 1074.15 164.844 1100.5 285.339",
    stroke: "url(#paint2_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-239.57 435.639C-41.6727 118.31 83.9277 43.1868 166.704 49.8777C227.038 54.7473 253.045 103.135 300.355 140.62C324.912 160.533 353.634 175.448 384.69 184.413C485.26 213.288 546.222 162.546 657.302 137.557C685.429 131.131 714.123 127.106 743.033 125.532C891.997 117.488 1081.62 165.505 1110.96 281.249",
    stroke: "url(#paint3_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-229.587 450.251C-34.181 137.672 91.3795 60.0568 175.265 63.734C235.777 66.3577 263.16 112.134 310.6 147.441C335.678 166.573 364.385 181.117 395.217 190.313C494.397 219.665 555.232 175.165 666.872 151.43C694.97 145.372 723.527 141.345 752.29 139.385C901.867 129.43 1089.21 166.278 1121.57 277.269",
    stroke: "url(#paint4_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-219.7 464.819C-26.7132 157.034 98.8893 74.7495 183.826 77.5684C244.454 79.518 273.274 120.977 320.798 154.286C346.383 172.602 375.074 186.775 405.673 196.213C503.463 226.044 564.121 187.785 676.154 165.329C704.245 159.578 732.704 155.525 761.355 153.195C911.544 141.238 1096.6 166.984 1131.96 273.247",
    stroke: "url(#paint5_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-209.597 479.387C-19.2206 176.42 106.285 93.9561 192.363 91.2917C253.16 89.6934 283.438 129.956 331.02 161.154C357.085 178.648 385.763 192.457 416.129 202.136C512.529 232.446 573.083 200.406 685.533 179.227C713.618 173.812 741.984 169.747 770.517 167.049C921.318 153.182 1104.1 167.669 1142.45 269.247",
    stroke: "url(#paint6_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-199.614 493.954C-11.801 195.782 113.712 110.781 200.925 105.26C261.851 101.327 293.647 138.73 341.241 167.975C367.764 184.63 396.442 198.069 426.584 207.969C521.57 238.778 582.021 213.003 694.91 193.034C721.177 188.416 749.223 183.969 779.678 180.79C931.114 164.944 1111.59 168.42 1152.94 265.201",
    stroke: "url(#paint7_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-189.631 508.522C-4.26047 215.167 121.142 127.855 209.462 119.051C270.543 112.984 303.882 147.529 351.511 174.775C378.493 190.582 407.187 203.679 437.112 213.847C530.709 245.135 591.006 225.557 704.36 206.91C730.749 202.561 758.723 198.159 788.936 194.6C940.792 176.798 1119.08 169.15 1163.43 261.157",
    stroke: "url(#paint8_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-179.623 523.068C3.23266 234.529 128.572 144.883 218.025 132.953C279.236 124.775 314.237 156.371 361.661 181.643C389.068 196.593 417.774 209.355 447.473 219.793C539.704 251.559 599.873 238.223 713.667 220.741C740.058 216.662 768.055 212.26 798.026 208.342C950.661 188.471 1126.57 169.744 1173.92 257.023",
    stroke: "url(#paint9_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-169.64 537.635C10.7005 253.892 136.001 161.956 226.514 146.788C287.856 136.522 324.423 165.124 371.835 188.51C399.66 202.571 428.398 214.989 457.88 225.694C548.697 257.938 608.738 250.821 722.997 234.729C749.51 230.963 777.436 226.539 807.139 222.286C960.386 200.347 1134 170.586 1184.38 253.112",
    stroke: "url(#paint10_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-159.657 552.203C18.1926 273.277 143.478 179.03 235.123 160.624C296.62 148.291 334.776 173.855 382.08 195.356C409.273 207.705 437.114 220.164 468.384 231.595C557.811 264.295 617.724 263.442 732.423 248.605C759.009 245.131 786.887 240.684 816.397 236.096C970.254 212.088 1141.58 171.294 1194.94 249.091",
    stroke: "url(#paint11_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M-149.673 566.77C25.6866 292.73 150.789 196.149 243.662 174.482C305.313 160.061 345.131 182.541 392.303 202.201C420.139 213.807 448.051 225.906 478.841 237.497C566.878 270.742 626.638 276.04 741.802 262.481C768.463 259.321 796.316 254.852 825.511 249.906C979.955 223.786 1149.03 172.002 1205.38 245.069",
    stroke: "url(#paint12_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-139.737 581.338C33.1544 312.026 158.363 213.29 252.2 188.341C314.006 171.899 355.484 191.205 402.525 209.07C431.029 219.887 458.986 231.648 489.201 243.422C575.872 277.077 635.456 288.685 751.18 276.403C777.939 273.511 805.72 269.021 834.673 263.761C989.727 235.483 1156.52 172.711 1215.87 241.049",
    stroke: "url(#paint13_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M-129.68 595.884C40.6485 331.39 165.771 230.478 260.763 202.178C322.748 183.693 365.863 199.803 412.724 215.895C441.895 225.9 469.946 237.37 499.754 249.302C584.987 283.436 644.491 301.262 760.559 290.258C788.542 287.331 816.345 283.067 843.859 277.483C999.477 247.159 1164.09 173.465 1226.36 237.007",
    stroke: "url(#paint14_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-119.697 610.451C48.1413 350.776 173.369 247.597 269.229 216.016C331.393 195.509 376.168 208.379 422.97 222.743C452.808 231.913 480.906 243.091 510.21 255.205C594.077 289.817 653.429 313.885 769.89 304.136C797.85 301.549 825.602 297.282 852.973 291.362C1009.22 258.701 1171.51 174.176 1236.87 232.898",
    stroke: "url(#paint15_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-109.712 625.019C55.6102 370.14 180.969 264.873 277.863 229.853C340.159 207.37 386.617 216.909 433.168 229.568C463.673 237.882 491.817 248.835 520.642 261.108C603.095 296.198 662.343 326.484 779.316 318.013C807.253 315.737 834.957 311.444 862.183 305.172C1018.95 270.399 1179 174.908 1247.36 228.968",
    stroke: "url(#paint16_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-99.6985 639.586C63.1092 389.623 188.381 282.094 286.405 243.724C348.952 219.221 396.999 225.407 443.371 236.427C474.638 243.84 502.756 254.568 531.102 267.023C612.165 302.544 671.26 339.116 788.697 331.921C816.607 329.942 844.268 325.623 871.347 319.015C1028.67 282.018 1186.49 175.633 1257.85 224.962",
    stroke: "url(#paint17_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-89.71 654.155C70.4854 408.905 195.935 299.359 294.971 257.664C357.721 231.185 407.354 233.974 453.596 243.423C485.458 250.002 513.743 260.459 541.561 273.074C621.234 309.117 680.201 351.883 798.077 345.899C825.959 344.217 853.58 339.87 880.51 332.927C1038.4 293.684 1194.11 176.516 1268.33 221.048",
    stroke: "url(#paint18_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-79.7209 668.722C78.0791 428.296 203.515 316.622 303.512 271.445C366.513 242.968 417.709 242.315 463.82 250.148C496.348 255.691 524.656 266.081 552.019 278.899C630.278 315.419 689.116 364.401 807.457 359.74C835.31 358.366 862.898 353.991 889.673 346.702C1048.1 305.146 1201.48 177.107 1278.82 216.954",
    stroke: "url(#paint19_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-69.7065 683.267C85.5779 447.666 211.096 333.998 311.983 285.294C375.212 254.864 427.946 250.724 473.926 257.009C507.12 261.539 535.499 271.815 562.359 284.747C639.252 321.767 697.961 376.988 816.741 373.581C844.57 372.493 872.134 368.089 898.764 360.478C1057.6 316.429 1208.88 177.856 1289.26 212.928",
    stroke: "url(#paint20_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-59.741 697.835C188.19 323.263 364.671 251.433 484.248 263.869C614.783 277.44 665.289 390.337 826.218 387.488C1015 384.122 1202.34 173.443 1299.8 208.925",
    stroke: "url(#paint21_linear_1345_5280)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1345_5280",
    x1: 402.815,
    y1: 4.90076,
    x2: 404.685,
    y2: 388.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1345_5280",
    x1: 413.169,
    y1: 19.4321,
    x2: 415.04,
    y2: 403.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1345_5280",
    x1: 423.428,
    y1: 33.8547,
    x2: 425.299,
    y2: 417.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1345_5280",
    x1: 433.709,
    y1: 48.1267,
    x2: 435.581,
    y2: 432.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1345_5280",
    x1: 444.062,
    y1: 62.2724,
    x2: 445.936,
    y2: 446.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1345_5280",
    x1: 454.256,
    y1: 76.1595,
    x2: 456.133,
    y2: 461.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1345_5280",
    x1: 464.606,
    y1: 89.9347,
    x2: 466.488,
    y2: 476.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1345_5280",
    x1: 474.896,
    y1: 103.68,
    x2: 476.781,
    y2: 490.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1345_5280",
    x1: 485.184,
    y1: 117.072,
    x2: 487.075,
    y2: 505.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1345_5280",
    x1: 495.484,
    y1: 130.377,
    x2: 497.381,
    y2: 519.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1345_5280",
    x1: 505.756,
    y1: 143.399,
    x2: 507.661,
    y2: 534.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1345_5280",
    x1: 516.076,
    y1: 156.185,
    x2: 517.989,
    y2: 548.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1345_5280",
    x1: 526.335,
    y1: 168.706,
    x2: 528.258,
    y2: 563.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1345_5280",
    x1: 536.591,
    y1: 180.944,
    x2: 538.526,
    y2: 578.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1345_5280",
    x1: 546.906,
    y1: 192.793,
    x2: 548.854,
    y2: 592.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1345_5280",
    x1: 557.194,
    y1: 204.249,
    x2: 559.157,
    y2: 607.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1345_5280",
    x1: 567.467,
    y1: 215.259,
    x2: 569.447,
    y2: 621.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1345_5280",
    x1: 577.684,
    y1: 215.227,
    x2: 579.735,
    y2: 636.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1345_5280",
    x1: 587.882,
    y1: 214.22,
    x2: 590.009,
    y2: 650.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1345_5280",
    x1: 598.075,
    y1: 212.512,
    x2: 600.281,
    y2: 665.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1345_5280",
    x1: 608.256,
    y1: 210.475,
    x2: 610.543,
    y2: 679.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1345_5280",
    x1: 618.458,
    y1: 208.099,
    x2: 620.827,
    y2: 694.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterPatern);
export default __webpack_public_path__ + "static/media/registerPatern.83a8e1d0f5b84f6f99e98b190422fa01.svg";
export { ForwardRef as ReactComponent };